import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { makeObservable, observable, runInAction } from "mobx";
import { BaseOptions } from "@devowl-wp/utils";
class OptionStore extends BaseOptions {
    others;
    pureSlug;
    pureSlugCamelCased;
    rootStore;
    constructor(rootStore){
        super();
        this.rootStore = rootStore;
        this.pureSlug = BaseOptions.getPureSlug(process.env.slug);
        this.pureSlugCamelCased = BaseOptions.getPureSlug(process.env.slug, true);
        makeObservable(this);
        const localized = window[this.pureSlugCamelCased];
        runInAction(()=>{
            const { others, ...rest } = localized;
            Object.assign(this, rest);
            this.others = observable(others);
        });
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], OptionStore.prototype, "others", void 0);
export { OptionStore };
